import React from "react";

const CorrectAudio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/assets/sounds/Correct.mp3" type="audio/mp3" />
    </audio>
  );
};

export default CorrectAudio;
